/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmEvalsCreateSuite } from "../../funcs/llmEvalsCreateSuite.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.CreateEvalSuiteRequest$inboundSchema,
};

export const tool$llmEvalsCreateSuite: ToolDefinition<typeof args> = {
  name: "llm-evals-create-suite",
  description: `Create an eval suite

Creates a team-scoped declarative eval suite. Dataset and Python grader files must be uploaded separately with purpose 'evals'.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmEvalsCreateSuite(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
